import axios from 'axios';
import API_BASE_URL from '../config/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to attach the token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Add a response interceptor to handle errors globally 
// (Optional but good practice)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // You can handle 401 (Unauthorized) here to trigger logout
        return Promise.reject(error);
    }
);

export default api;
